
export class ConsumeTokenRequest {
    employeeCode: string;
    deviceRfId?: string;
    scanTime: string;

    /**
     * 
     * @param employeeCode 
     * @param deviceRfId 
     * @param scanTime
     */
    constructor(employeeCode: string, deviceRfId: string, scanTime: string) {
        this.employeeCode = employeeCode;
        this.deviceRfId = deviceRfId;
        this.scanTime = scanTime;
    }
}